
import React from "react";

const sizes = {
    headline_headline_medium: "font-sfpro text-[1.75rem] font-bold md:text-[1.63rem] sm:text-[1.44rem]",
    label_label__small: "font-sfpro text-[0.88rem] font-medium",
    title_title__medium: "font-sfpro text-[1.0erem] font-bold sm:text-[0.81rem]",
    label_label_____large: "font-sfpro text-[1.00rem] font-medium sm:text-[0.81rem]",
    title_title__mid: "font-sfpro text-[1.13rem] font-bold sm:text-[0.94rem]",
    headline_headline_small: "text-[1.50rem] font-bold md:text-[1.38rem] sm: text-[1.25rem]",
    title_title_large: "font-sfpro text-[1.38rem] font-bold sm:text-[1.13rem]",
    title_title__small: "font-sfpro text-[0.88rem] font-bold",
    textlg: "text-[2.25rem] font-medium md:text-[2.13rem] sm:text-[1.88rem]",
    headingxs: "text-[0.88rem] font-semibold",
    headings: "text-[1.0erem] font-semibold sm:text-[0.81rem]",
    headingmd: "text-[1.13rem] font-semibold sm:text-[0.94rem]",
    headinglg: "text-[1.25rem] font-semibold sm:text-[1.86rem]",
    headingxl: "text-[1.38rem] font-bold sm:text-[1.13rem]",
    heading2x1: "text-[1.50rem] font-bold md:text-[1.38rem] sm:text-[1.25rem]",
    heading3x1: "text-[2.25rem] font-black md:text-[2.13rem] sm:text-[1.88rem]",
    heading4x1: "text-[3.50rem] font-semibold md:text-[3.00rem] sm:text-[2.94rem]",
    heading5x1: "text-[4.0ørem] font-bold md:text-[3.00rem]",

};
const Heading = ({ children, className = "",
    size = "label_label___small", as, ...restProps }) => {
    const Component = as || "h6";
    return (
        <Component className={`text-white-a700 font-sfpro ${className} ${sizes[size]}`} {...restProps}>
            {children}
        </Component>
    );
};
export { Heading };